import React, {useCallback, useEffect, useMemo, useState} from 'react';
import ToggleComponent from "v4/components/utils/ToggleComponent/ToggleComponent";
import {QUOTE_ADD, QUOTE_FORM, QUOTE_ITEM, QUOTE_ITEM_FORM} from "v4/data/apiRoutes";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";
import FormEntityLayout from "v4/layouts/FormEntityLayout/FormEntityLayout";
import ProspectQuotesCustomTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesCustomTab/components/ProspectQuotesCustomTabListing/ProspectQuotesCustomTabListing";
import ProspectQuotesRecalculateButton
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/ProspectQuotesRecalculateButton/ProspectQuotesRecalculateButton";
import ProspectQuotesCustomTabShow
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesCustomTab/components/ProspectQuotesCustomTabShow/ProspectQuotesCustomTabShow";

export default function ProspectQuotesCustomTab() {
    const { currentRoute } = useNavigation();
    const isAdd = currentRoute.routeType === 'ADD';
    const isShow = currentRoute.routeType === 'SHOW';
    const isEdit = currentRoute.routeType === 'EDIT';
    const isListing = currentRoute.routeType === 'LISTING';

    const { prospect: prospectId, quote: showId } = currentRoute.params;
    const [quoteData, setQuoteData] = useState(null);

    const onGetData = useCallback((data) => {
        const hydraMember = (typeof data === 'function' ? data(quoteData) : data?.['hydra:member']) ?? data;
        setQuoteData(hydraMember);
    }, [quoteData]);

    useEffect(() => {
        quoteData && onGetData(quoteData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quoteData]);

    const fetchFormParameters = useMemo(() => ({
        id: showId,
        prospectId,
        tabId: currentRoute.route.metadata.tab_id,
    }), [showId, prospectId, currentRoute.route.metadata.tab_id]);

    return (
        <>
            <ToggleComponent isShowing={isListing}>
                <ProspectQuotesCustomTabListing prospectId={prospectId} currentRoute={currentRoute}/>
            </ToggleComponent>

            <ToggleComponent isShowing={isShow && !isEdit}
                             shouldRemoveFromDom={true}
                             className="prospect-tab__prospect showing">
                <ProspectQuotesCustomTabShow prospectId={prospectId}
                                             showId={showId}
                                             onGetData={onGetData}
                                             quoteData={quoteData}
                                             setQuoteData={setQuoteData}/>
            </ToggleComponent>

            <ToggleComponent isShowing={isAdd || isEdit}
                             shouldRemoveFromDom={true}
                             className="prospect-tab__prospect editing">
                <FormEntityLayout title="devis_offres"
                                  formRouteName={isAdd ? QUOTE_FORM : QUOTE_ITEM_FORM}
                                  submitRouteName={isAdd ? QUOTE_ADD : QUOTE_ITEM}
                                  fetchFormParameters={fetchFormParameters}
                                  additionalButtons={() => <ProspectQuotesRecalculateButton eventForRecalculate={`beforesave:${isAdd ? QUOTE_ADD : QUOTE_ITEM}`}/>}
                                  whenSubmitted={whenSubmitted}/>
            </ToggleComponent>
        </>
    )
}

function whenSubmitted(history) {
    history.push(history.location.pathname.replace(/\/(edit|add)$/, ''), {hasToRefresh: true});
}
